import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initNative } from './lib/native'
import { initAuthSession } from './lib/auth'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// 네이티브(Capacitor) 셸 초기화 — 웹에서는 no-op.
void initNative()

// Firebase 세션 → useAuthStore 미러링(로그인 상태 반영). 미설정 시 no-op.
void initAuthSession()
